import React from 'react'
import { Input } from '@/components/ui'
import type { OrganizationFormValues } from '@/features/organization/schemas/organizationForm.schema'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import { FieldGrid, FieldGroup, SettingsPane } from '../organization-ui'

export interface AddressPaneProps {
  register: UseFormRegister<OrganizationFormValues>
  errors: FieldErrors<OrganizationFormValues>
  disabled?: boolean
}

export const AddressPane: React.FC<AddressPaneProps> = ({
  register,
  errors,
  disabled = false,
}) => (
  <SettingsPane
    title="Registered address"
    description="The primary business location used across records and correspondence. Keep it aligned with your registration and payroll filings."
  >
    <FieldGroup label="Street">
      <div className="max-w-2xl">
        <Input
          label="Street address"
          placeholder="221B Baker Street"
          error={errors.street?.message}
          disabled={disabled}
          {...register('street')}
        />
      </div>
    </FieldGroup>

    <FieldGroup label="Region and postal">
      <FieldGrid>
        <Input label="City" error={errors.city?.message} disabled={disabled} {...register('city')} />
        <Input
          label="State or province"
          error={errors.state?.message}
          disabled={disabled}
          {...register('state')}
        />
        <Input
          label="Country"
          error={errors.country?.message}
          disabled={disabled}
          {...register('country')}
        />
        <Input
          label="Postal code"
          error={errors.postalCode?.message}
          disabled={disabled}
          {...register('postalCode')}
        />
      </FieldGrid>
    </FieldGroup>
  </SettingsPane>
)

AddressPane.displayName = 'AddressPane'
